import Vue from 'vue'
import Vuex from 'vuex'
//Nta1: Procesos anexos
import Process1_1 from './Process1.1.js'
import Process1_2 from './Process1.2.js'
import Process2_1 from './Process2.1.js'
import Process2_3 from './Process2.3.js'
import Process2_5 from './Process2.5.js'
import Process2_7 from './Process2.7.js'
import Process2_9 from './Process2.9.js'
import Process3_1 from './Process3.1.js'
import Process4_1 from './Process4.1.js'
import Process5_1 from './Process5.1.js'
// Modulos 
import UserManager from './UserManager'
import Statistics from './Statistics'
import Tours from './Tours'
import CalendarEvents from './CalendarEvents'

Vue.use(Vuex)
const interaction = {
    StaticInfo: "<p>This activity can be as short or as extensive as the Consultant recommends or the Client chooses, depending on the progress of the process.</p>",
    SectionsInfo: []
}

export default new Vuex.Store({
    state: {
        openBar: true,
        PhaseSelected: undefined,
        ProcessSelected: undefined,
        SubProcessSelected: undefined,
        projects: [{
                Title: "Design and operation for hydraulic fracturing, Well PE32 – Technical support",
                contry: "Brasil",
                Basin: "Santos",
                Field: "Orocual",
                PhasesSlopes: 6,
                PhasesDone: 6,
                Contrated: 160,
                DataAnalysis: 124,
                PeerReview: 36,
                HoursRemaining: 0,
                Consultants: [{
                    Image: require('../assets/persona1.jpg'),
                    Name: "Martín Essenfeld",
                    tel: "+ 57 3054023255 ",
                    correo: "martin.essenfeld@egepconsultores.com"
                }, {
                    Image: require('../assets/persona2.jpg'),
                    Name: "Luis Vera",
                    tel: "+57 3054055670",
                    correo: "Luis.vera@egepconsultores.com"
                }, ],
                funcional: true,
            },
            {
                Title: "Analysis and production diagnostics for 2 wells in the Belen field",
                contry: "Brasil",
                Basin: "Santos",
                Field: "Orocual",
                PhasesSlopes: 2,
                PhasesDone: 2,
                Contrated: 30,
                DataAnalysis: 24,
                PeerReview: 6,
                HoursRemaining: 0,
                Consultants: [{
                    Image: require('../assets/persona1.jpg'),
                    Name: "Martín E.",
                }, ],
                funcional: false,
            },

        ],
        ProccesProyects: {
            ChartPhases: {
                chartData: [
                    ["Phase", "%", { role: "style" }, { role: "annotation" }],
                    ["1", 100, "color: #FFD505; opacity: 1;", "100"],
                    ["2", 100, "color: #7FF0FF; opacity: 1;", "100"],
                    ["3", 100, "color: #321E50; opacity: 1;", "100"],
                    ["4", 100, "color: #5F3EA7; opacity: 1;", "100"],
                    ["5", 100, "color: #3FA7FF; opacity: 1;", "100"],
                    ["6", 100, "color: #838383; opacity: 1;", "100"],
                ],
                chartOptions: {
                    title: "Percentage of Completion",
                    legend: { position: "none" },
                    bar: { groupWidth: "95%" },
                    bars: "horizontal",
                    hAxis: { minValue: 0, maxValue: 100 },
                },
            },

            ChartDataAnalysis: {
                chartData: [
                    ["Phase", "h", { role: "style" }, { role: "annotation" }],
                    ["1", 28, "color: #F68B23; opacity: 0.6;", "28"],
                    ["2", 66, "color: #7FAEE2; opacity: 0.6;", "66"],
                    ["3", 10, "color: #9DCDFB; opacity: 0.6;", "10"],
                    ["4", 8, "color: #4472C4; opacity: 0.6;", "8"],
                    ["5", 4, "color: #22163E; opacity: 0.6;", "4"],
                    ["6", 8, "color: #FFA406; opacity: 0.6;", "8"],
                ],
                chartOptions: {
                    title: "Hours per Phase",
                    legend: { position: "none" },
                    bars: "horizontal",
                },
            },
            ChartPeerReview: {
                chartData: [
                    ["Phase", "h", { role: "style" }, { role: "annotation" }],
                    ["1", 6, "color: #F68B23; opacity: 0.6;", "6"],
                    ["2", 12, "color: #7FAEE2; opacity: 0.6;", "21"],
                    ["3", 0, "color: #9DCDFB; opacity: 0.6;", "0"],
                    ["4", 4, "color: #4472C4; opacity: 0.6;", "4"],
                    ["5", 1, "color: #22163E; opacity: 0.6;", "1"],
                    ["6", 4, "color: #FFA406; opacity: 0.6;", "4"],
                ],
                chartOptions: {
                    title: "Hours per Phase",
                    legend: { position: "none" },
                    bars: "horizontal",
                },
            },

        },
        //ESTRUCTURA DE DATOS DE LA FASE Y PROCESOS -> Nota:El contenido de los procesos se anexa desde documentos externos Nta:1
        Phases: [{
                id: "1",
                name: "General Proyect",
                complete: false,
                active: false,
                process: [{
                        id: "1.1",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Data and Information Diagnostics",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process1_1.Description
                            },
                            {
                                name: "Overview",
                                content: Process1_1.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process1_1.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process1_1.Deliverables

                            }
                        ]
                    },
                    {
                        id: "1.2",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Initial Screening",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process1_2.Description
                            },
                            {
                                name: "Overview",
                                content: Process1_2.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process1_2.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process1_2.Deliverables
                            }
                        ]
                    },
                    {
                        id: "1.3",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }, ]
                    }
                ]
            },
            {
                id: "2",
                name: "Planning",
                complete: false,
                active: false,
                process: [{
                        id: "2.1",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Design",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process2_1.Description
                            },
                            {
                                name: "Overview",
                                content: Process2_1.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process2_1.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process2_1.Deliverables
                            },
                        ]
                    },
                    {
                        id: "2.2",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }, ]
                    },
                    {
                        id: "2.3",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Wells Selection",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process2_3.Description
                            },
                            {
                                name: "Overview",
                                content: Process2_3.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process2_3.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process2_3.Deliverables
                            }
                        ]
                    },
                    {
                        id: "2.4",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }]
                    },
                    {
                        id: "2.5",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Operational Plan",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process2_5.Description
                            },
                            {
                                name: "Overview",
                                content: Process2_5.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process2_5.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process2_5.Deliverables
                            }
                        ]
                    },
                    {
                        id: "2.6",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }, ]
                    },
                    {
                        id: "2.7",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Economic Evaluation",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process2_7.Description
                            },
                            {
                                name: "Overview",
                                content: Process2_7.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process2_7.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process2_7.Deliverables
                            }
                        ]
                    },
                    {
                        id: "2.8",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }]
                    },
                    {
                        id: "2.9",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Service Company Evaluation",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process2_9.Description
                            },
                            {
                                name: "Overview",
                                content: Process2_9.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process2_9.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process2_9.Deliverables
                            }
                        ]
                    },
                    {
                        id: "2.10",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }]
                    }
                ]
            },
            {
                id: "3",
                name: "Execution",
                complete: false,
                active: false,
                process: [{
                        id: "3.1",
                        porcent: 100,
                        LastInteraction: false,
                        name: "EGEP Operations Monitoring ",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process3_1.Description
                            },
                            {
                                name: "Overview",
                                content: Process3_1.Overview
                            }
                        ]
                    },
                    {
                        id: "3.2",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }, ]
                    },
                ]
            },
            {
                id: "4",
                name: "Evaluation of results",
                complete: false,
                active: false,
                process: [{
                        id: "4.1",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Results diagnostics",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process4_1.Description
                            },
                            {
                                name: "Overview",
                                content: Process4_1.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process4_1.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: Process4_1.Deliverables
                            }
                        ]
                    },
                    {
                        id: "4.2",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }]
                    }
                ]
            },
            {
                id: "5",
                name: "Lessons learned",
                complete: false,
                active: false,
                process: [{
                        id: "5.1",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Lessons learned",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Description",
                                content: Process5_1.Description
                            },
                            {
                                name: "Overview",
                                content: Process5_1.Overview
                            },
                            {
                                name: "Inputs",
                                content: Process5_1.Inputs
                            },
                            {
                                name: "Deliverables",
                                content: ""
                            }
                        ]
                    },
                    {
                        id: "5.2",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Interaction with the client",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                            name: "Interaction",
                            content: interaction
                        }]
                    },
                ]
            },
            {
                id: "6",
                name: "Reports",
                complete: false,
                active: true,
                process: [{
                        id: "6.1",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Consolidated Report",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Deliverables",
                                content: ""
                            },
                            {
                                name: "Interaction",
                                content: interaction
                            },
                        ]
                    },
                    {
                        id: "6.2",
                        porcent: 100,
                        LastInteraction: false,
                        name: "Management Summary",
                        complete: false,
                        inProcess: false,
                        SubProcess: [{
                                name: "Deliverables",
                                content: ""
                            },
                            {
                                name: "Interaction",
                                content: interaction
                            }
                        ]
                    },
                ]
            },
        ],
    },
    mutations: {
        setOpenBar(state, value) {
            state.openBar = value
        },
        toggleBar(state) {
            state.openBar = !state.openBar
        },
        setPhaseSelected(state, id) {
            state.PhaseSelected = state.Phases.find(phase => phase.id === id)
        },
        setProcessSelected(state, id) {
            state.ProcessSelected = state.PhaseSelected.process.find(pro => pro.id === id)
        },
        setSubProcessSelected(state, name) {
            state.SubProcessSelected = state.ProcessSelected.SubProcess.find(sub => sub.name === name)
        }
    },
    actions: {},
    modules: {
        UserManager,
        Statistics,
        Tours,
        CalendarEvents
    },
    getters: {
        getOpenBar: state => {
            return state.openBar
        },
        getPhaseActive: state => {
            return state.Phases[0]
        },
        getPhaseSelected: state => {
            return state.PhaseSelected
        },
        getProcessSelected: state => {
            return state.ProcessSelected
        },
        getSubProcessSelected: state => {
            return state.SubProcessSelected
        },
        getProccesProyects: state => {
            return state.ProccesProyects
        },
        getConsultants: state => index => {
            return state.projects[index].Consultants
        }
    }
})